import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import HelmetWrapper from "../../HelmetWrapper";
import { selectAuth } from "../../components/auth/auth.selector";
import MealsStructure from "../../components/diet/meal/MealsStructure";
import SearchNButtons from "../../components/common-components/SearchNButtons";
import { fetchCustomerIntentData } from "../../redux/reducers/apiSlice";
import CustIntentForm from "../../components/lead-management/followup-system/CustIntentForm";
import ReactVortoxSpinner from "../../components/common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../components/payment-link-system/PaymentLinkTable";
import { formattedLongDate } from "../../components/common-data/Converts";
import Loader from "../../components/ui/Loader";
import { showConfirmAlert } from "../../components/components-react/ReactAlert";
import { toast } from "react-toastify";
import { commonDeleteApi } from "../../redux/reducers/deleteApiSlice";
import { deleteCustomerIntent } from "../../data/ApiEndpoints";

const CustomerIntent = () => {
  const dispatch = useDispatch();
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  const { followupStatusLoading, customerIntentCategory } = useSelector(
    (state) => state.api
  );
  const { loading } = useSelector((state) => state.putApi);

  const iniModValues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);
  const [isPage, setIsPage] = useState(0);
  const iniAllFilters = {
    isActive: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
    status: allFilters.isActive?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniDataValues = {
    allIntents: [],
    pagination: [],
  };
  const [dataValues, setDataValues] = useState(iniDataValues);

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getCustomerIntent(filters) {
    dispatch(
      fetchCustomerIntentData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: deleteCustomerIntent,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(
              response?.message || "Customer Intent is deleted successfully!"
            );
            getCustomerIntent(filters);
          } else {
            toast.error(response?.message || "Can not delete Customer Intent!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete Customer Intent");
        }
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure, you want to delete this Customer Intent!`
      );
    } else {
      toast.error("UID required!");
    }
  };

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
    }));
  }, [isPage]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      status: allFilters.isActive?.value || "",
    }));
    setIsPage(0);
  }, [allFilters.isActive]);

  useEffect(() => {
    getCustomerIntent(filters);
  }, [filters]);

  useEffect(() => {
    if (
      customerIntentCategory?.status &&
      customerIntentCategory?.data?.length > 0
    ) {
      setDataValues((prevs) => ({
        ...prevs,
        allIntents: customerIntentCategory.data,
        pagination: customerIntentCategory?.pagination || [],
      }));
    } else {
      setDataValues(iniDataValues);
    }
  }, [customerIntentCategory]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  const tbColumns = [
    {
      dataField: "name",
      text: "Intent Name",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.name?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius27"
            style={{
              background: row?.status === "active" ? "#E2EFD5" : "#F3DADA",
              color: row?.status === "active" ? "#379C00" : "#D90000",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formattedLongDate(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon edit"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                rowData: row,
                cardName: "edit",
              }))
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-pencil-fill"
              viewBox="0 0 16 16"
            >
              <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg>
          </button>

          <button
            className="actionBtn icon delete"
            onClick={(e) => {
              const payload = {
                uid: row?.uid,
              };
              handleDelete(payload);
            }}
            style={{ cursor: "not-allowed" }}
            disabled={true}
          >
            {loading ? (
              <Loader />
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-trash3-fill"
                viewBox="0 0 16 16"
                style={{
                  color: "gray",
                }}
              >
                <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
              </svg>
            )}
          </button>
        </div>
      ),
    },
  ];

  return (
    <HelmetWrapper title="WTF: Customer Intent">
      <Container className="bg-cloud-k px-50px" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Add Followup Status Modal"
          ariaHideApp={false}
        >
          <CustIntentForm
            userInfoData={userInfoData}
            closeModal={onCloseModal}
            callFunction={() => getCustomerIntent(filters)}
            rowData={modValues.rowData}
            isEdit={modValues.cardName === "edit"}
          />
        </Modal>

        <Row>
          <Col>
            <MealsStructure text={"Customer Intent"} />
          </Col>
        </Row>
        <Row>
          <Col>
            <SearchNButtons
              pageName={"intents"}
              btnText={"+ Add New Customer Intent Category"}
              onClickAdd={() => {
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "add",
                }));
              }}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="fullWidthFlexCenter overflowAuto separatedTable mt30">
              {followupStatusLoading ? (
                <ReactVortoxSpinner />
              ) : (
                <PaymentLinkTable
                  tableData={dataValues.allIntents}
                  tableColumns={tbColumns}
                  tablePagination={dataValues.pagination}
                  isPage={isPage}
                  setIsPage={(value) => setIsPage(value)}
                />
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default CustomerIntent;
